import { render } from "./DashboardScheduledServices.vue?vue&type=template&id=4d627a4a"
import script from "./DashboardScheduledServices.vue?vue&type=script&lang=js"
export * from "./DashboardScheduledServices.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__